import axios from 'axios';
import * as Sentry from '@sentry/vue';

const LTV_TIMEOUT_MS = 1000;

/**
 * Fetches the LTV (EUR) reported to Google Ads for the team's billing country and the given plan.
 * Returns undefined when there is none, so the conversion is sent without a value. The timeout
 * keeps a slow lookup from holding back conversion tracking on the payment complete page.
 */
export async function fetchLtv(
  apiBaseUrl: string,
  planName: string,
  interval: string,
  intervalCount: number
): Promise<number | undefined> {
  try {
    const resp = await axios.get(`${apiBaseUrl}/google-ads/ltv`, {
      params: { plan: planName, interval, interval_count: intervalCount },
      timeout: LTV_TIMEOUT_MS,
    });

    return resp.data.ltv;
  } catch (error: any) {
    // Uncharted countries and plans (e.g. non-profit, enterprise) are expected to have no LTV.
    if (![404, 422].includes(error?.response?.status)) {
      Sentry.captureException(error, {
        tags: { type: 'API-Error', method: 'fetchLtv' },
        extra: { message: 'Failed fetching the Google Ads LTV' },
      });
    }

    return undefined;
  }
}
